<template>
  <div>
    <!-- title -->
    <div class="header">
      <h1 class="page-title">
        <i v-if="productName">{{productName + '-'}}</i>代客下单
      </h1>
    </div>
    <el-card
      class="box-card card"
      v-loading="loading"
      element-loading-text="正在识别文件名 请稍后~~~"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="sy_tit">
        <img src="../../../assets/user/zu1076.png" />
        <span>读取文件</span>
      </div>
      <div class="fileBox">
        <div class="file_tit"></div>
        <div id="ossfile" v-show="fileFlag===true || notUploadList.length">
          <div
            class="reset_file"
            style="margin-bottom: 3px;"
            v-for="item in notUploadList"
            :key="item.id"
          >

            <template v-if="item.status==2 ||item.status==4 || item.status < 1 ">
              {{item.file}}
              <b>
                <span style="color: #c7254e; margin-left:10px;">
                  <button
                    :id="item.id"
                    :index="item.otherno==null ? '4' : '1'"
                     :title="item.status_text"
                    class="resetfileBtn"
                    style="padding: 1px 5px;border-radius: 3px;background-color: #faad14;color: #fff;font-size:12px"
                  >立即下单</button>
                  <i
                    class="el-icon-error delCar"
                    @click="delCar(item.id,$event)"
                    style="font-size:18px; margin-left:5px; cursor:pointer;"
                  ></i>
                  <input type="hidden" :value="item.file" />
                </span>
              </b>
            </template>
            <template v-else-if="item.status==3">
              {{item.file}}
              <b>
                <span style="color: #c7254e; margin-left:10px;">
                  <button
                    :id="item.id"
                    :index="item.otherno==null ? '4' : '1'"
                    class="checkAddress"
                    style="padding: 1px 5px;border-radius: 3px;background-color: #faad14;color: #fff;font-size:12px"
                  >选择地址</button>
                  <i
                    class="el-icon-error delCar"
                    @click="delCar(item.id,$event)"
                    style="font-size:18px; margin-left:5px; cursor:pointer;"
                  ></i>
                  <input type="hidden" :value="item.file" />
                </span>
              </b>
            </template>
          </div>
        </div>
        <div class="fileList" v-show="fileFlag===false&&!notUploadList.length">
          <div class="file_msg">
            <div class="imgBox">
              <img src="../../../assets/user/zu1030.png" />
            </div>
            <p>目前暂无上传内容</p>
          </div>
        </div>
      </div>
      <div class="f">
        <form name="theform">
          <input style="display:none" type="radio" name="myradio" checked="true" value="local_name" />
          <input style="display:none" type="radio" name="myradio" value="random_name" />
          <input style="display:none" type="text" id="dirname" :value="filePath" size="50" />
        </form>
        <div class="contaniner">
          <button class="clearFile" @click="clearFileList">清空列表</button>
          <div id="selectfiles">
            <a href="javascript:void(0);" class="btn batchBtn">上传文件</a>
          </div>
        </div>
      </div>
      <div class="main clearfix" v-show="JSON.stringify(tableData)!='[]'">
        <span class="msg">
          一共
          <i>{{totalNum}}</i>
          条订单
        </span>
        <div class="sy_tit">
          <img src="../../../assets/user/zu1076.png" />
          <span>文件列表</span>
        </div>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          max-height="500"
          v-loading="loading1"
        >
          <el-table-column :resizable="false" type="index" label="序号"></el-table-column>
          <el-table-column :resizable="false" type="jname" label="客户简称"  width="160">
          <template  slot-scope="scope">
              <el-select v-model="scope.row.uid"  @change="editCar($event,scope.row.uid,scope.row.id)" clearable filterable>
                <el-option
                    v-for="(uu,i) in uList"
                    :key="uu.id"
                    :label="uu.jname"
                    :value="uu.id"
                     ></el-option>
                </el-select>
           </template>

          </el-table-column>
          <el-table-column :resizable="false" prop="file" label="文件名" width="250"></el-table-column>
          <el-table-column :resizable="false" prop="product_name" label="产品种类" width="70"></el-table-column>
		  <el-table-column :resizable="false" prop="title" label="规格" width="150"></el-table-column>
          <el-table-column :resizable="false" prop="number" label="数量" width="70"></el-table-column>
          <el-table-column :resizable="false" prop="kuanshu" label="款数" width="60"></el-table-column>
          <el-table-column :resizable="false" label="商品价格" width="90">
            <template slot-scope="scope">
              <input
                type="text"
                class="e_price"
                :value="scope.row.craft_price + scope.row.goods_price"
                disabled
              />
              <button
                class="e_btn"
                @click="editPrice($event,scope.row.craft_price + scope.row.goods_price,scope.row.id)"
              >修改价格</button>
            </template>
          </el-table-column>
		  <el-table-column :resizable="false" prop="packprice" label="包装费" width="70"></el-table-column>
          <el-table-column :resizable="false" prop="product_weight" label="重量(kg)" width="70"></el-table-column>
          <el-table-column :resizable="false" prop="express_name" label="默认快递" width="70"></el-table-column>
          <el-table-column :resizable="false" prop="shipping_fee" label="默认快递费" width="70"></el-table-column>
          <el-table-column :resizable="false" prop="total_price" label="小计" width="70"></el-table-column>
          <el-table-column :resizable="false" prop="shopping_name" label="收货信息" width="250">
            <template slot-scope="scope">
              <div v-if="scope.row.shopping_name!==null">
                <p>收 货 人：{{scope.row.shopping_name}}
                <p v-show="scope.row.ext_number">分机号:{{scope.row.ext_number}}</p>
                <button
                    class="e_btn"
                    @click="editcarAddress(scope.row)"
                  >修改</button>
                  </p>
                  <p>手机:{{scope.row.shopping_phone}}</p>

                <p>配送地址：{{scope.row.address_text}}</p>
                <p>详细地址：{{scope.row.address_query}}</p>
              </div>
              <el-button class="checkAddress" type="primary" v-else size="mini">选择地址</el-button>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="danger" @click="delCar(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <button @click="goZhifu" class="sy_zf">去支付</button>
      </div>
    </el-card>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="90%"
      fullscreen
      :before-close="handleClose"
      @close="close"
      top="1vh"
      class="sy_dialog"
    >
      <div
        v-loading="loading2"
        element-loading-text="正在加载热门商品 请稍后~~~"
        element-loading-spinner="el-icon-loading"
      >
        <iframe
          id="iframe"
          width="100%"
          style="min-height:800px"
          frameborder="0"
          name="showHere"
          scrolling="auto"
          :src="Pid ? url+'/#/quoteprice/content?id='+Pid : url+'/#/quoteprice/index'"
        ></iframe>
        <!-- <iframe
          id="iframe"
          width="100%"
          style="min-height:900px"
          frameborder="0"
          name="showHere"
          scrolling="auto"
          :src="Pid ? 'http://192.168.0.13:8080/#/quoteprice/content?id='+Pid : 'http://192.168.0.13:8080/#/quoteprice/content' "
        ></iframe>-->
      </div>
    </el-dialog>

  <!-- 添加备注 -->
    <el-dialog :visible.sync="remarksVisible2" class="dia-title" title="修改价格" width="40%">
       <el-form
        style="margin-top:10px"
        :model="carData"
        :rules="rules"
        ref="carData"
        label-width="100px"
        class="demo-carData"
      >
        <el-form-item label="备注" prop="remarks">
          <el-input v-model="carData.remarks" placeholder="备注长度不超过10个字符"></el-input>
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input v-model="carData.price" ></el-input>
        </el-form-item>
         <el-form-item label="客服密码" prop="serverpwd">
          <el-input v-model="carData.serverpwd" type="text"></el-input>
        </el-form-item>
        <el-form-item  prop="id">
          <el-input v-model="carData.id" type="hidden"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="remarksVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="remarksForm('carData')" class="diz">确定</el-button>
      </span>
    </el-dialog>

    <!-- 地址管理 -->
    <el-dialog title="地址管理" :visible.sync="AddressDialog" width="50%">
      <el-button type="primary" size="small" id="addAddress" @click="addaddress()">添加地址</el-button>
      <el-input style="width:200px;margin-left:20px" size="small"  v-model="soaddress"   placeholder="输入姓名,电话,地址搜索"></el-input>
      <el-button style="margin-left:20px" size="small" type="success" @click="autoaddress">搜索</el-button>
      <div id="addressBox" style="height: 410px;overflow-y: scroll;">
        <template v-if="JSON.stringify(AddressList) !='[]'">
          <div
            v-for="item in AddressList"
            :id="item.id"
            class="clearfix address-item"
            :key="item.id"
          >
            <button class="un">{{item.shopping_name}}</button>
            <p class="address1" :title="item.address">{{item.address}}</p>
            <p class="Addressquery" :title="item.query">{{item.query}}</p>
            <p class="AddressPhone">{{item.shopping_phone}}</p>
            <div class="caozuo" v-if="item.def==0">
               <button  class="el-button el-button--primary el-button--small" @click="checkAddress(item.id)">选择</button>
              <span style="margin-left: 10px;" class="set" @click="settingAddress(item.id)">设置默认</span>
              <a class="edit" @click="editShowDialog(item)">修改</a>
              <button class="del" @click="delAddress(item.id)">删除</button>
            </div>
            <div class="caozuo" v-else>
               <button  class="el-button el-button--primary el-button--small" @click="checkAddress(item.id)">选择</button>
              <button style="margin-left: 10px;" class="def">默认</button>
               <a class="edit" @click="editShowDialog(item)">修改</a>
            </div>
          </div>
        </template>
        <div v-else>暂无数据</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="AddressDialog = false">取 消</el-button>

      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible2" class="dia-title" title="地址管理" width="40%">
      <el-form
        style="margin-top:10px"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
      <el-form-item label="自动识别">
        <el-input style="width:450px" v-model="autoAdd" placeholder="淘宝单号,文件名,手机,姓名"></el-input>
        <el-button style="margin-left:20px" type="success" @click="autoSpot">开始识别</el-button>
      </el-form-item>
        <el-form-item label="收货人姓名" prop="shopping_name">
          <el-input v-model="ruleForm.shopping_name" placeholder="姓名长度不超过25个字符"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="shopping_phone">
          <el-input v-model="ruleForm.shopping_phone" placeholder="请输入收货人的手机号码"></el-input>
        </el-form-item>
        <v-distpicker  class="address_picker" style="margin:0 0 10px 100px" @selected="onSelected"></v-distpicker>
        <el-form-item label="详细地址" prop="query">
          <el-input v-model="ruleForm.query" placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" class="diz">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible3" class="dia-title" title="修改地址" width="40%">
      <el-form
        style="margin-top:10px"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
      <el-form-item label="自动识别">
        <el-input style="width:450px" v-model="autoAdd" placeholder="淘宝单号,文件名,手机,姓名"></el-input>
        <el-button style="margin-left:20px" type="success" @click="autoSpot">开始识别</el-button>
      </el-form-item>
        <el-form-item label="收货人姓名" prop="shopping_name">
          <el-input v-model="ruleForm.shopping_name" placeholder="姓名长度不超过25个字符"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="shopping_phone">
          <el-input v-model="ruleForm.shopping_phone" placeholder="请输入收货人的手机号码"></el-input>
        </el-form-item>
        <el-form-item label="分机号" prop="ext_number">
          <el-input v-model="ruleForm.ext_number" placeholder="请输入分机号"></el-input>
        </el-form-item>
        <v-distpicker  class="address_picker address_picker2" style="margin:0 0 10px 100px" @selected="onSelected"></v-distpicker>
        <el-form-item label="详细地址" prop="query">
          <el-input v-model="ruleForm.query" placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="editcarAddresspost('ruleForm')" class="diz">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import '../../../../public/PLupload/lib/crypto1/crypto/crypto.js'
import '../../../../public/PLupload/lib/crypto1/hmac/hmac.js'
import '../../../../public/PLupload/lib/crypto1/sha1/sha1.js'
import '../../../../public/PLupload/lib/base64.js'
import plupload from 'plupload'
import QuotePrice from '../../baojia/indexBox'
import VDistpicker from 'v-distpicker'
import { log } from 'util'

let accessid = 'LTAIKIMZYqT7o3sd'
let accesskey = 'bOqt3eOIbDRYkaDIgb84Q8dKyJF6fT'
let host = 'https://yunshanyin.oss-cn-shenzhen.aliyuncs.com'

let g_dirname = ''
let g_object_name = ''
let g_object_name_type = ''
let timestamp
let now = (timestamp = Date.parse(new Date()) / 1000)
let pos = ''
let suffix = ''
const baseUlr = window.location.host
const url = !baseUlr.includes('192')
  ? 'https://' + baseUlr
  : 'https://www.yunshanyin.net'

var policyText = {
  expiration: '2120-12-01T12:00:00.000Z', // 设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
  conditions: [
    ['content-length-range', 0, 104857600000000] // 设置上传文件的大小限制
  ]
}
var policyBase64 = window.Base64.encode(JSON.stringify(policyText))
let message = policyBase64
var bytes = Crypto.HMAC(Crypto.SHA1, message, accesskey, { asBytes: true })
var signature = Crypto.util.bytesToBase64(bytes)

function check_object_radio() {
  var tt = document.getElementsByName('myradio')
  for (var i = 0; i < tt.length; i++) {
    if (tt[i].checked) {
      g_object_name_type = tt[i].value
      break
    }
  }
}

function get_dirname() {
  let dir = document.getElementById('dirname').value
  if (dir != '' && dir.indexOf('/') != dir.length - 1) {
    dir = dir + '/'
  }
  g_dirname = dir
}

function random_string(len, filename) {
  let pwd = filename
  return pwd
}

function get_suffix(filename) {
  pos = filename.lastIndexOf('.')
  suffix = ''
  if (pos != -1) {
    suffix = filename.substring(pos)
  }

  return suffix
}

function calculate_object_name(filename) {
  if (g_object_name_type == 'local_name') {
    g_object_name += '${filename}'
  } else if (g_object_name_type == 'random_name') {
    suffix = get_suffix(filename)
    g_object_name = g_dirname + random_string(10, filename)
  }
  return ''
}

function get_uploaded_object_name(filename) {
  if (g_object_name_type == 'local_name') {
    let tmp_name = g_object_name
    tmp_name = tmp_name.replace('${filename}', filename)
    return tmp_name
  } else if (g_object_name_type == 'random_name') {
    return g_object_name
  }
}

function set_upload_param(up, filename, ret) {
  g_object_name = g_dirname
  if (filename != '') {
    suffix = get_suffix(filename)
    calculate_object_name(filename)
  }
  let new_multipart_params = {
    key: g_object_name,
    policy: policyBase64,
    OSSAccessKeyId: accessid,
    success_action_status: '200', // 让服务端返回200,不然，默认会返回204
    signature: signature
  }

  up.setOption({
    url: host,
    multipart_params: new_multipart_params
  })

  up.start()
}

let tim
export default {
  data() {
    return {
      Pid: '',
      productName: '',
      filePath: '',
      loading: false,
      tableData: [],
       autoAdd: '',
      soaddress: '',
      carData: [],
      loading1: false,
      totalNum: 0,
      fileFlag: false,
      dialogVisible: false,
      dialogTitle: '',
      loading2: true,
      url: '',
      notUploadList: [],
      AddressList: [],
      uList: [],
      AddressDialog: false,
      // 订单id
      orderId: '',
      // 快递id
      addressID: '',
      CarId: '',
      rules: {
        shopping_name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
        ],
        shopping_phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { min: 11, max: 11, message: '请核对手机号码', trigger: 'blur' }
        ],
        query: [
          { required: true, message: '请输入配送地址', trigger: 'blur' },
          {
            min: 5,
            max: 120,
            message: '详细地址长度需要在5-120个汉字或字符之间',
            trigger: 'blur'
          }
        ]
      },
      ruleForm: {
        // 省id
        provice_id: '',
        // 省市区id
        address: [],
        // 详细地址信息
        query: '',
        // 名字
        shopping_name: '',
        // 手机号码
        shopping_phone: '',
        ext_number: '',
        
        token: window.localStorage.getItem('token'),
        id: ''
      },
      dialogVisible2: false,
      dialogVisible3: false,
      remarksVisible2: false
    }
  },
  components: {
    QuotePrice,
    VDistpicker
  },
  created() {
    this.Pid = this.$route.query.id

    const baseUlr = window.location.host
    this.url = !baseUlr.includes('192')
      ? 'https://' + baseUlr
      : 'https://www.yunshanyin.net'

    let u = JSON.parse(window.localStorage.getItem('u'))
    this.filePath =
      'uploads/' +
      u.mobile +
      '/' +
      new Date().toLocaleDateString().replace(/\//g, '-')
    if (this.Pid) {
      this.getUserInfo()
    }
    this.queryNotUploadFile()
    this.queryOrderList()
    this.userLst()
  },
  methods: {
    // 修改价格
    editPrice(e, price, carid) {
      let flag = true
      let that = this

      that.remarksVisible2 = true

      $.ajax({
            type: 'post',
            url: url + '/api/car/carinfo',
            data: {
              id: carid
            },
            dataType: 'json',
            success: function(res) {
              if (res.code == 1) {
                that.carData = res.data
              } else {
                that.carData = []
              }
            }
          })
    },

    // 修改简称
    editCar(e, uid, carid) {
      let that = this

      if(uid && carid){
        $.ajax({
          url: url + '/api/car/editcar',
          type: 'Post',
          dataType: 'json',
          data: { id: carid, uid: uid },
          success: function(res) {
            if (res.code) {
            that.$message('用户修改成功', 'success')
            that.queryOrderList()
          }
          }
        })
      }

    },
    // 验证信息填写是否完全
    remarksForm(formName) {
      var that = this
      if (!this.carData.remarks) {
        this.$message('请输入备注', 'error')
        return
      }
      if (this.carData.remarks.length > 20) {
        this.$message('备注字符不能大于10', 'error')
        return
      }
         var token = window.localStorage.getItem('token')
            $.ajax({
            url: url + '/api/car/editcar',
            type: 'Post',
            dataType: 'json',
            data: { id: this.carData.id, token: token, price: this.carData.price, remarks: this.carData.remarks, serverpwd: this.carData.serverpwd },
            success: function(res) {
              if (res.code) {
              that.$confirm('修改成功', '提示')
              that.remarksVisible2 = false
              that.queryOrderList()
            } else {
               that.$message(res.msg, 'error')
            }
            }
          })
    },

    // 验证信息填写是否完全
    submitForm(formName) {
      if (this.ruleForm.address.length < 3) {
        this.$message('请选择完整的省市区', 'error')
        return
      }
      for (let i = 0; i < this.ruleForm.address.length; i++) {
        if (!this.ruleForm.address[i]) {
          this.$message('请选择完整的省市区', 'error')
          return
        }
      }

      this.$refs[formName].validate(async valid => {
        if (!valid) {

        } else {
          if (!this.ruleForm.provice_id || !this.ruleForm.address) {
            this.$message('请选择详细地区信息', '提示')
            return
          }

          let param = new URLSearchParams()
          for (let key in this.ruleForm) {
            param.append(key, this.ruleForm[key])
          }
          // 添加地址
          if (this.flag == 0) {
            const { data: res } = await this.$http({
              method: 'post',
              url: 'api/address/addaddress',
              data: param
            })
            if (res.code == 1) {
              this.$confirm('添加地址信息成功！', '提示')
              this.queryAddress()
              this.dialogVisible2 = false
              this.$refs[formName].resetFields()
              this.ruleForm.address = this.ruleForm.address.split(',')
            } else {
              this.$message.error('添加地址失败')
            }
          } else if (this.flag == 1) {
            const { data: resu } = await this.$http({
              method: 'post',
              url: 'api/address/editaddress',
              data: param
            })
            if (resu.code == 1) {
              this.$message.success('修改地址成功！', '提示')
              this.queryAddress()
              this.dialogVisible2 = false
              this.$refs[formName].resetFields()
              this.ruleForm.address = this.ruleForm.address.split(',')
            }
          }
        }
      })
    },
    editcarAddresspost(formName) {
      if (this.ruleForm.address.length < 3) {
        this.$message('请选择完整的省市区', 'error')
        return
      }
      for (let i = 0; i < this.ruleForm.address.length; i++) {
        if (!this.ruleForm.address[i]) {
          this.$message('请选择完整的省市区', 'error')
          return
        }
      }

      this.$refs[formName].validate(async valid => {
        if (!valid) {

        } else {
          if (!this.ruleForm.provice_id || !this.ruleForm.address) {
            this.$message('请选择详细地区信息', '提示')
            return
          }

          let param = new URLSearchParams()
          for (let key in this.ruleForm) {
            param.append(key, this.ruleForm[key])
          }
          const { data: resu } = await this.$http({
            method: 'post',
            url: 'api/address/editcaraddress',
            data: param
          })
          if (resu.code == 1) {
            this.$message.success('修改地址成功！', '提示')

            this.dialogVisible3 = false
            this.$refs[formName].resetFields()
            $('.address_picker2 select:first option:first').text(0)
            $('.address_picker2 select:eq(1) option:first').text(0)
            $('.address_picker2 select:last option:first').text(0)
            this.queryOrderList()
          }
        }
      })
    },
    onSelected(data) {
      this.ruleForm.address = []
      this.ruleForm.provice_id = ''
      this.ruleForm.provice_id = data.province.code
      for (let key in data) {
        this.ruleForm.address.push(data[key].code)
      }

      // console.log(this.ruleForm)
    },
    // 添加地址
    addaddress() {
      this.flag = 0
      this.dialogVisible2 = true
      $('.diz span').text('添加地址')
    },
    // 切换地址
    async checkAddress(id) {
     let address_id = id
      if (address_id == '') {
        this.$confirm('请选择收货地址', '提示')
        return
      }
      let param = new URLSearchParams()
      param.append('id', this.CarId)
      param.append('address_id', address_id)
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/car/editcaraddress',
        data: param
      })
      if (res.code == 1) {
        this.$confirm('修改收货地址成功', '提示')
        $('#' + this.CarId)
          .parents('.reset_file')
          .hide()
        this.queryOrderList()
        this.AddressDialog = false
      }
    },
    // 点击编辑
    editShowDialog(data) {
      this.ruleForm.shopping_name = data.shopping_name
      this.ruleForm.shopping_phone = data.shopping_phone
      this.ruleForm.ext_number = res.data.ext_number
      this.ruleForm.query = data.query
      this.ruleForm.id = data.id
      this.dialogVisible2 = true
      this.flag = 1
      $('.diz span').text('修改地址')
    },
    // 点击编辑
    editcarAddress(data) {
 this.dialogVisible3 = true

this.$nextTick(() => {
  this.ruleForm.shopping_name = data.shopping_name
  this.ruleForm.shopping_phone = data.shopping_phone
   this.ruleForm.ext_number = data.ext_number
  this.ruleForm.query = data.address_query
  this.ruleForm.address = data.address_text.split('/')
   this.ruleForm.provice_id = data.provice_id
   this.ruleForm.id = data.id
   console.log(data)
    $('.address_picker2 select:first option:first').text(this.ruleForm.address[0])
    $('.address_picker2 select:eq(1) option:first').text(this.ruleForm.address[1])
    $('.address_picker2 select:last option:first').text(this.ruleForm.address[2])
    $('.address_picker2 select:first option:first').value = this.ruleForm.address[0]
    $('.address_picker2 select:eq(1) option:first').value = this.ruleForm.address[1]
    $('.address_picker2 select:last option:first').value = this.ruleForm.address[2]
  })

      $('.diz span').text('修改地址')
    },
    // 设置默认地址
    async settingAddress(id) {
      let param = new URLSearchParams()
      param.append('id', id)
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/address/defaddress',
        data: param
      })
      if (res.code == 1) {
        this.$message.success('设置成功')
        this.queryAddress()
      }
    },
    // 删除地址
    delAddress(id) {
      this.$confirmm('此操作将永久删除该地址, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let param = new URLSearchParams()
          param.append('id', id)
          const { data: res } = await this.$http({
            method: 'post',
            url: '/api/address/deladdress',
            data: param
          })
          // console.log(res)
          if (res.code == 1) {
            this.$confirm('删除成功', '提示')
          }
          this.queryAddress()
        })
        .catch(() => {})
    },
    async queryNotUploadFile() {
      // status=1 cartype=2
      let param = new URLSearchParams()
      param.append('status', 1)
      param.append('moren', 1)
      param.append('cartype', 2)
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http.post('api/car/indexD', param)
      if (res.data) {
        res.data.length !== 0
          ? (this.notUploadList = res.data)
          : (this.notUploadList = [])
      }
    },
    // 删除订单
    async delCar(id, e = null) {
      let param = new URLSearchParams()
      param.append('ids', id)
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/car/delcar',
        data: param
      })
      if (res.code == 1) {
        this.$confirm('删除成功', '提示')
      }
      if (e) {
        $(e.target)
          .parents('.reset_file')
          .hide()
      }

      if (!e) {
        this.queryOrderList()
      }
    },
    // 批量下单列表
    async queryOrderList() {
      this.loading1 = true
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      param.append('cartype', 2)
      const { data: result } = await this.$http.post('api/car/indexD', param)
      this.loading1 = false
      if (result.data) {
        this.tableData = result.data.reverse()
        this.totalNum = this.tableData.length
      } else {
        this.tableData = []
        this.totalNum = 0
      }
    },
     // 客户列表
    async userLst() {
      var token = window.localStorage.getItem('token')
       $.ajax({
        type: 'post',
        url: url + '/api/index/ulst',
        data: { token: token },
        dataType: 'json',
        success: res => {
          if (res.code) {
            this.uList = res.data
          }
        }
      })

      console.log(this.uList)
    },
    goZhifu() {
        var token = window.localStorage.getItem('token')
          var that = this
        $.ajax({
              type: 'post',
              url: url + '/api/car/detailD',
              data: { token: token, cartype: 2 },
              dataType: 'json',
              success: function(res) {
                if (res.data.length > 0) {
                  window.sessionStorage.setItem('cartype', 2)
                  that.$router.push('/paymentOrderD')
                } else {
                  that.$confirmm('请检查客户简称', '提示')
                }
              }
        })
    },
    clearFileList() {
      $('#ossfile').empty()
    },
    handleClose() {
      this.$confirmm('确定关闭吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.dialogVisible = false
          window.sessionStorage.removeItem('carid')
          window.sessionStorage.removeItem('carno')
        })
        .catch(() => {})
    },
    // dialog关闭
    close() {
      if (
        $('#iframe')
          .contents()
          .find('.sy-skin li').length
      ) {
        $('#iframe')
          .contents()
          .find('.sy-skin li')
          .removeClass('disabled current syc')
        $('#iframe')
          .contents()
          .find('.sy-skin label')
          .removeClass('sy_dx disabled syc')
        $('#iframe')
          .contents()
          .find('.sy-skin label')
          .siblings('input')
          .removeAttr('disabled')
        $('#iframe')
          .contents()
          .find('.sy-skin label input:checkbox')
          .prop('checked', false)
        $('#iframe')
          .contents()
          .find('.select_product_info')
          .text('')
        $('#iframe')
          .contents()
          .find('.money')
          .text('')
      }
    },
    // 递归排序
    compare(property) {
      return function(a, b) {
        return b[property] - a[property]
      }
    },
    // 查询地址列表
   async queryAddress(id = '', linmt = 100) {
      let token = window.localStorage.getItem('token')
      if (token) {
        let param = new URLSearchParams()
        param.append('token', token)
        param.append('linmt', linmt)
        const { data: res } = await this.$http({
          method: 'post',
          url: '/api/address/index',
          data: param
        })
        if (res.code == 1) {
          this.AddressList = res.data.sort(this.compare('def'))
        } else {
          this.AddressList = []
        }
      }
    },
    // 自动识别
    async autoSpot() {
      const {
        data: res
      } = await this.$http.get(
        '/api/index/strtoaddress?str=' + this.autoAdd + '&token=' + window.localStorage.getItem('token')
      )
      if (res.code) {
        this.ruleForm.provice_id = res.data.province_id
        this.ruleForm.query = res.data.detail
        this.ruleForm.shopping_phone = res.data.mobile
        this.ruleForm.shopping_name = res.data.name
        this.ruleForm.ext_number = res.data.ext_number
        this.ruleForm.address =
          res.data.province_id +
          ',' +
          res.data.city_id +
          ',' +
          res.data.county_id
        $('.address_picker select:first option:first').text(
          res.data.province_name
        )
      //  this.selectProductInfo.data.region_id = res.data.province_id
        $('.address_picker select:eq(1) option:first').text(res.data.city_name)
        $('.address_picker select:last option:first').text(res.data.county_name)
        $('.address_picker select:first option:first')
      } else {
        $('.address_picker select:first option:first').val('')
        $('.address_picker select:eq(1) option:first').val(0)
        $('.address_picker select:last option:first').val(0)
        $('.address_picker select:first option:first').val(0)
        this.$confirm('搜索不到地址,请输入准确的信息', '提示')
      }
    },
    async autoaddress() {
        $('#addressBox>div').hide()
        $("#addressBox>div:contains('" + this.soaddress + "')").show()
    },
    // 用户信息
    async getUserInfo() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      if (this.Pid) {
        param.append('id', this.Pid)
      }
      const { data: res } = await this.$http.post('api/mine/index', param)
      if (res.code) {
        this.productName = res.data.product_name
        console.log(this.productName)
      }
    }
  },
  mounted() {
    const that = this
    let file1
    let carArr
    let flag = false
    let reFlagFile = true
    var uploader = new plupload.Uploader({
      runtimes: 'html5,flash,silverlight,html4',
      browse_button: 'selectfiles',
      flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
      silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
      url: 'http://oss.aliyuncs.com',
      filters: {
        mime_types: [
          { title: 'Image files', extensions: 'jpg' },
          { title: 'Png files', extensions: 'png' },
          { title: 'Rar files', extensions: 'rar' },
          { title: 'Zip files', extensions: 'zip' },
          { title: 'Cdr files', extensions: 'cdr' }
        ]
        // prevent_duplicates: true //不允许选取重复文件
      },
      init: {
        PostInit: function() {
          // document.getElementById('ossfile').innerHTML = ''
        },
        FilesAdded: function(up, files) {
          file1 = files
          carArr = []
          let fileArr = []

          for (let i = file1.length - 1; i >= 0; i--) {
            that.loading = true
            let fname = file1[i].name
            let obj = {}
            obj.token = window.localStorage.getItem('token')
            obj.file = file1[i].name
            if (that.Pid) {
              obj.id = that.Pid
            }
            obj.custom_id=1;
            $.ajax({
              type: 'post',
              url: url + '/api/order/strtoorder',
              data: obj,
              dataType: 'json',
              success: function(res) {
                that.fileFlag = true
                this.loading1 = false
                if(res.code==0){
                  that.$confirm(res.msg, '提示')
                  that.loading = false
                  return false;
                }
                if (res.data[0].status == 0) {
                  for (let j = 0; j < file1.length; j++) {
                    if (fname == file1[j].name) {
                      uploader.splice(j, 1)
                      let html = `<div class="err_file">
                        ${fname}
                        <b>
                          <span style="color: #c7254e; margin-left:10px;">
                           `+res.msg+`
                          </span>
                        </b>
                      </div>`
                      $('#ossfile').prepend(html)
                    }
                  }
                  if (i <= 0) {
                    that.loading = false
                    setTimeout(() => {
                      set_upload_param(uploader, '', false)

                      plupload.each(fileArr, function(file) {
                        document.getElementById('ossfile').innerHTML +=
                          '<div id="' +
                          file.id +
                          '">' +
                          file.name +
                          ' (' +
                          plupload.formatSize(file.size) +
                          ')<b></b>' +
                          '<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>' +
                          '</div>'
                      })
                      that.loading = false
                    }, 300)
                  }
                } else if (res.data[0].status == 2) {
                  for (let j = 0; j < file1.length; j++) {
                    if (fname == file1[j].name) {
                      let carid = res.data[0].carid
                      file1[i].carId = carid
                      file1[i].no = 1
                      file1[i].title = res.msg
                      fileArr.push(file1[i])
                    }
                  }

                  if (i <= 0) {
                    that.loading = false
                    setTimeout(() => {
                      set_upload_param(uploader, '', false)

                      plupload.each(fileArr, function(file) {
                        document.getElementById('ossfile').innerHTML +=
                          '<div id="' +
                          file.id +
                          '">' +
                          file.name +
                          ' (' +
                          plupload.formatSize(file.size) +
                          ')<b></b>' +
                          '<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>' +
                          '</div>'
                      })
                      that.loading = false
                    }, 300)
                  }
                } else if (res.data[0].status == 3) {
                  for (let j = 0; j < file1.length; j++) {
                    if (fname == file1[j].name) {
                      let carid = res.data[0].carid
                      file1[i].carId = carid
                      file1[i].no = 3
                      file1[i].title = res.msg
                      fileArr.push(file1[i])
                    }
                  }

                  if (i <= 0) {
                    that.loading = false
                    setTimeout(() => {
                      set_upload_param(uploader, '', false)
                      plupload.each(fileArr, function(file) {
                        document.getElementById('ossfile').innerHTML +=
                          '<div id="' +
                          file.id +
                          '">' +
                          file.name +
                          ' (' +
                          plupload.formatSize(file.size) +
                          ')<b></b>' +
                          '<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>' +
                          '</div>'
                      })
                      that.loading = false
                    }, 300)
                  }
                } else if (res.data[0].status == 4) {
                  for (let j = 0; j < file1.length; j++) {
                    if (fname == file1[j].name) {
                      let carid = res.data[0].carid
                      file1[i].carId = carid
                      file1[i].no = 4
                      file1[i].title = res.msg
                      fileArr.push(file1[i])
                    }
                  }

                  if (i <= 0) {
                    that.loading = false
                    setTimeout(() => {
                      set_upload_param(uploader, '', false)

                      plupload.each(fileArr, function(file) {
                        document.getElementById('ossfile').innerHTML +=
                          '<div id="' +
                          file.id +
                          '">' +
                          file.name +
                          ' (' +
                          plupload.formatSize(file.size) +
                          ')<b></b>' +
                          '<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>' +
                          '</div>'
                      })
                      that.loading = false
                    }, 300)
                  }
                } else if(res.data[0].status <1) {
                  for (let j = 0; j < file1.length; j++) {
                    if (fname == file1[j].name) {
                      let carid = res.data[0].carid
                      file1[i].carId = carid
                      file1[i].no = 1
                      file1[i].title = res.msg

                      fileArr.push(file1[i])
                    }
                  }

                  if (i <= 0) {
                    that.loading = false
                    setTimeout(() => {
                      set_upload_param(uploader, '', false)

                      plupload.each(fileArr, function(file) {
                        document.getElementById('ossfile').innerHTML +=
                          '<div id="' +
                          file.id +
                          '">' +
                          file.name +
                          ' (' +
                          plupload.formatSize(file.size) +
                          ')<b></b>' +
                          '<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>' +
                          '</div>'
                      })
                      that.loading = false
                    }, 300)
                  }
                }else{
                  for (let j = 0; j < file1.length; j++) {
                    if (fname == file1[j].name) {
                      let carid = res.data[0].carid
                      file1[i].carId = carid

                      file1[i].title = res.msg

                      fileArr.push(file1[i])
                    }
                  }

                  if (i <= 0) {
                    that.loading = false
                    setTimeout(() => {
                      set_upload_param(uploader, '', false)

                      plupload.each(fileArr, function(file) {
                        document.getElementById('ossfile').innerHTML +=
                          '<div id="' +
                          file.id +
                          '">' +
                          file.name +
                          ' (' +
                          plupload.formatSize(file.size) +
                          ')<b></b>' +
                          '<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>' +
                          '</div>'
                      })
                      that.loading = false
                    }, 300)
                  }
                }
              }
            })
          }
        },
        BeforeUpload: function(up, file1) {
          check_object_radio()
          get_dirname()
          set_upload_param(up, file1.name, true)
        },
        // 上传进度显示
        UploadProgress: function(up, file) {
          if (document.getElementById(file.id) !== null) {
            var d = document.getElementById(file.id)
            d.getElementsByTagName('b')[0].innerHTML =
              '<span>' + file.percent + '%</span>'
            var prog = d.getElementsByTagName('div')[0]
            var progBar = prog.getElementsByTagName('div')[0]
            progBar.style.width = 14 * file.percent + 'px'
            progBar.setAttribute('aria-valuenow', file.percent)
          }
        },
        // 上传完成后
        FileUploaded: async function(up, file, info) {
          if (file.no === 1) {
            let html = `<div class="reset_file" style="margin-bottom: 3px;">
                          ${file.name}
                          <b>
                            <span style="color: #c7254e; margin-left:10px;">
                             <button id="${file.carId}" index="${
              file.no
            }" class="resetfileBtn" title="${file.title}" style="padding: 1px 5px;border-radius: 3px;background-color: #faad14;color: #fff;font-size:12px">
                                立即下单
                             </button>
                            <i
                            id="${file.carId}"
                            class="el-icon-error delCar-r"
                            style="font-size:18px; margin-left:5px; cursor:pointer;"
                            ></i>
                              <input type="hidden" value="${file.name}">
                              <i style="display:none">${JSON.stringify(
                                file.id
                              )}</i>
                            </span>
                          </b>
                        </div>`
            $('#' + file.id).empty()
            $('#' + file.id).append(html)
          } else if (file.no === 3) {
            let html = `<div class="reset_file" style="margin-bottom: 3px;">
                          ${file.name}
                          <b>
                            <span style="color: #c7254e; margin-left:10px;">
                             <button id="${file.carId}" index="${
              file.no
            }" class="checkAddress" title="${file.title}" style="padding: 1px 5px;border-radius: 3px;background-color: #faad14;color: #fff;font-size:12px">
                                选择地址
                             </button>

                              <input type="hidden" value="${file.name}">
                              <i style="display:none">${JSON.stringify(
                                file.id
                              )}</i>
                            </span>
                          </b>
                        </div>`
            $('#' + file.id).empty()
            $('#' + file.id).append(html)
          } else if (file.no === 4) {
            let html = `<div class="reset_file" style="margin-bottom: 3px;">
                          ${file.name}
                          <b>
                            <span style="color: #c7254e; margin-left:10px;">
                             <button id="${file.carId}" index="${
              file.no
            }" class="resetfileBtn" title="${file.title}" style="padding: 1px 5px;border-radius: 3px;background-color: #faad14;color: #fff;font-size:12px">
                                立即下单
                             </button>
                          <i
                            id="${file.carId}"
                            class="el-icon-error delCar-r "
                            style="font-size:18px; margin-left:5px; cursor:pointer;"
                          ></i>
                              <input type="hidden" value="${file.name}">
                              <i style="display:none">${JSON.stringify(
                                file.id
                              )}</i>
                            </span>
                          </b>
                        </div>`
            $('#' + file.id).empty()
            $('#' + file.id).append(html)
          }
          if (info.status == 200) {
            let filename =
              'https://yunshanyin.oss-cn-shenzhen.aliyuncs.com/' +
              get_uploaded_object_name(file.name)
            if (!filename) {
              return
            }
            let params = new URLSearchParams()
            params.append('filename', filename)
            params.append('file', file.name)
            params.append('id', file.carId)
            const { data: res } = await that.$http.post(
              'api/car/editcar',
              params
            )
            if (!file.no) {
              $('#' + file.id)
                .find('span')
                .text('\u2714')
              $('#' + file.id)
                .find('span')
                .css('color', '#a77c5a')
                .css('fontSize', '16px')
            }

            that.queryOrderList()
          } else {
            document
              .getElementById(file.id)
              .getElementsByTagName('b')[0].innerHTML = info.response
          }
        },

        Error: function(up, err) {
          // console.log('出错', up, err)
        }
      }
    })

    uploader.init()

    $('#ossfile').on('click', '.reset_file .resetfileBtn', function() {
      let fileId = $(this)
        .siblings('i')
        .text()
      fileId = fileId.slice(1, fileId.length - 1)
      let carid = $(this).attr('id')
      let carno = $(this).attr('index')
      that.dialogTitle = $(this)
        .siblings('input')
        .val()
      that.dialogVisible = true
      that.$nextTick(() => {
        let iframe = document.getElementById('iframe')
        window.sessionStorage.setItem('carid', carid)
        window.sessionStorage.setItem('carno', carno)

        iframe.onload = function() {
          tim = setInterval(() => {
            if (
              iframe.contentDocument.getElementsByClassName('body')[0] !==
              undefined
            ) {
              iframe.contentDocument.getElementsByClassName(
                'el-header'
              )[0].style.display = 'none'
              iframe.contentDocument.getElementsByClassName(
                'navitems-group'
              )[0].style.display = 'none'
              iframe.contentDocument
                .getElementsByClassName('body')[0]
                .classList.add('resP')
              iframe.contentDocument.getElementsByClassName(
                'btn-group'
              )[0].style.display = 'block'
              iframe.contentDocument.getElementsByClassName(
                'sy-item-info-l'
              )[0].style.display = 'none'

              if (
                iframe.contentDocument.getElementsByClassName('table_detail')[0]
              ) {
                iframe.contentDocument.getElementsByClassName(
                  'table_detail'
                )[0].style.display = 'none'
              }
              $('#iframe')
                .contents()
                .find('#sy_Address')
                .show()
              clearInterval(tim)
            }

            that.loading2 = false
          }, 200)
          let timer1
          timer1 = setInterval(() => {
            if (
              iframe.contentDocument.getElementsByClassName('el-header').length
            ) {
              iframe.contentDocument.getElementsByClassName(
                'el-header'
              )[0].style.display = 'none'
              iframe.contentDocument.getElementsByClassName(
                'navitems-group'
              )[0].style.display = 'none'
              clearInterval(timer1)
            }
          }, 100)
        }
        let timer
        timer = setInterval(() => {
          if (window.sessionStorage.getItem('ok')) {
            window.sessionStorage.removeItem('ok')
            if (that.dialogVisible) {
              that.dialogVisible = false
            }
            that.$confirm('下单成功', '提示')
            $(this).hide()
            $(this)
              .parent('span')
              .text('下单成功')
            $(this)
              .parent('span')
              .css('color', '#a77c5a')
              .css('fontSize', '16px')
            clearInterval(timer)
            that.dialogVisible = false
            that.queryNotUploadFile()
            that.queryOrderList()
          }
        }, 200)
      })
    })
    // 选择地址
    $('#ossfile').on('click', '.reset_file .checkAddress', function() {
      that.CarId = $(this).attr('id')
      that.AddressDialog = true
      that.queryAddress()
      // dom更新完成添加点击事件
      that.$nextTick(() => {
        $('#addressBox').on('click', '.address-item', function() {
          $(this)
            .addClass('active')
            .siblings('.address-item')
            .removeClass('active')
        })
      })
    })
    // 删除

    $('#ossfile').on('click', '.delCar-r', function() {
      let carid = $(this).attr('id')

      $.ajax({
        type: 'post',
        url: url + '/api/car/delcar',
        data: {
          ids: carid
        },
        dataType: 'json',
        success: res => {
          if (res.code) {
            that.$confirm('删除成功', '提示')
            $(this)
              .parents('.reset_file')
              .hide()
          }
        }
      })
    })
  },
  destroyed() {
    window.sessionStorage.removeItem('carid')
    window.sessionStorage.removeItem('carno')
    clearInterval(tim)
  }
}
</script>

<style lang="less" scoped>
.active {
  background-color: #d9e9d5;
}
.header {
  margin-bottom: 20px;
  .page-title {
    font-size: 24px;
  }
}
.card {
  min-height: 700px;
  .sy_tit {
    height: 20px;
    line-height: 20px;
    margin-bottom: 20px;
    i {
      width: 16px;
      height: 20px;
      vertical-align: middle;
    }
    span {
      font-size: 12px;
      color: #666;
      margin-left: 5px;
    }
  }
  .fileBox {
    min-height: 400px;
    width: 90%;
    border: 1px solid rgba(232, 232, 232, 1);
    .file_tit {
      width: 100%;
      height: 50px;
      background: #fafafa;
      opacity: 1;
      border-radius: 8px 8px 0px 0px;
      border-bottom: 1px solid rgba(232, 232, 232, 1);
    }
    .fileList {
      margin-top: 50px;
      .file_msg {
        width: 300px;
        margin: auto;
        .imgBox {
          width: 208px;
          padding-left: 20px;
          margin: auto;
        }
        p {
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 41px;
          color: rgba(191, 191, 191, 1);
          text-align: center;
        }
      }
    }
  }
  .f {
    position: absolute;
    right: 20px;
    top: 520px;
    .contaniner {
      text-align: center;
      .clearFile {
        width: 120px;
        height: 34px;
        line-height: 34px;
        background: rgba(14, 175, 99, 0.08);
        border: 1px solid rgba(14, 175, 99, 1);
        opacity: 1;
        border-radius: 4px;
        margin-bottom: 20px;
      }
      #selectfiles {
        width: 250px;
        margin: auto;
        cursor: pointer;
      }
      .batchBtn {
        width: 120px;
        height: 34px;
        line-height: 34px;
        background: rgba(24, 144, 255, 0.08);
        border: 1px solid #1890ff;
        opacity: 1;
        border-radius: 4px;
        color: #1890ff;
        margin: 0;
        padding: 0;
      }
    }
  }
  .main {
    width: 100%;
    max-height: 500px;
    position: relative;
    margin-top: 40px;
    .orange {
      background-color: #f0fff0;
      border-bottom: 2px solid #a77c5a;
    }
    .cell {
      p {
        text-align: left;
      }
    }
    #table {
      th {
        background-color: #fafafa;
        border: 1px solid #eee;
        height: 38px;
        line-height: 38px;
        text-align: center;
      }
      tr {
        border: 1px solid #eee;
      }
      td {
        font-size: 12px;
        color: #666666;
        border: 1px solid #eee;
        text-align: center;
        padding: 10px;
      }
    }
    .msg {
      float: right;
      font-size: 18px;
      i {
        color: #e83030;
      }
    }
    .sy_zf {
      float: right;
      margin: 50px 50px 0 0;
      width: 200px;
      height: 50px;
      font-size: 18px;
      color: #fff;
      background-color: #a77c5a;
      cursor: pointer;
    }
  }
}
#ossfile {
  padding-left: 3px;
}
#addressBox {
  margin-top: 10px;
  .address-item {
    cursor: pointer;
    margin-bottom: 10px;
    margin-bottom: 10px;
    .un {
      float: left;
      width: 80px;
      height: 30px;
      background-color: #edfff6;
      border: 1px solid #a77c5a;
      font-size: 12px;
      color: #a77c5a;
      margin-right: 10px;
    }
    p {
      float: left;
      line-height: 30px;
    }
    .address1 {
      margin-left: 5px;
      max-width: 140px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .Addressquery {
      margin: 0 5px;
      max-width: 350px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .caozuo {
      width:200px;
      float: right;
      font-size: 12px;
      line-height: 30px;
      .set {
        color: #4da5ff;
        cursor: pointer;
      }
      .edit {
        color: #a77c5a;
        margin-left: 8px;
        cursor: pointer;
      }
      .del {
        background: #fff;
        margin-left: 8px;
      }
      .def {
        color: #fff;
        background-color: #bfbfbf;
        padding: 2px 5px;
      }
    }
  }
}
.e_btn {
  padding: 3px 5px;
  background-color: #1890ff;
  border-radius: 3px;
  color: #fff;
  font-size: 12px;
}
</style>
